import { Button, Checkbox, CheckboxProps, Form } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

const ReservationsAndClients = ({}: any) => {
  const intl = useIntl();
  const data = [
    { name: "السماح بالاطلاع على جميع الفروع", values: [1, 2, 3, 4] },
    { name: "السماح بالاطلاع على جميع الفروع", values: [1, 2, 3, 4] },
    { name: "السماح بالاطلاع على جميع الفروع", values: [1, 2, 3, 4] },
    { name: "السماح بالاطلاع على جميع الفروع", values: [1, 2, 3, 4] },
  ];

  const onChange: CheckboxProps["onChange"] = (e: any) => {
    console.log(`checked = ${e.target.checked}`);
  };
  const onFinish = (values: any) => {
    console.log(values);
  };
  return (
    <>
      <div className="bg-[#EEF0FF]  p-6">
        <header className="bg-white p-4 rounded-lg flex items-center justify-between">
          <h4 className="font-semibold text-sm text-black w-full">
            <FormattedMessage id="permissionDescription" />
          </h4>
          <div className="flex items-center justify-between w-full">
            <h5 className="text-color-primary font-semibold w-1/4 text-center">
              <FormattedMessage id="lowLevel" />
            </h5>
            <h5 className="text-color-primary font-semibold w-1/4 text-center">
              <FormattedMessage id="midLevel" />
            </h5>
            <h5 className="text-color-primary font-semibold w-1/4 text-center">
              <FormattedMessage id="highLevel" />
            </h5>
            <h5 className="text-color-primary font-semibold w-1/4 text-center">
              <FormattedMessage id="admin" />
            </h5>
          </div>
        </header>
      </div>
      <Form
        name="Permissions"
        onFinish={onFinish}
        layout="vertical"
        className=""
        dir="rtl"
      >
        <div className="w-full flex flex-col p-6 pt-0 gap-4 items-center justify-center bg-[#EEF0FF] rounded-b-lg">
          {data.map((e) => {
            return (
              <div className="bg-white p-4 rounded-lg flex items-center w-full">
                <h5 className="font-semibold text-sm text-black w-full">
                  <FormattedMessage id="allowViewingAllBranches" />
                </h5>
                <div className="flex items-center justify-between w-full">
                  <Form.Item
                    className="flex items-center justify-center w-full !mb-0"
                    name="low"
                  >
                    <Checkbox className="!mb-0"></Checkbox>
                  </Form.Item>
                  <Form.Item
                    className="flex items-center justify-center w-full !mb-0"
                    name="mid"
                  >
                    <Checkbox className="!mb-0"></Checkbox>
                  </Form.Item>
                  <Form.Item
                    className="flex items-center justify-center w-full !mb-0"
                    name="high"
                  >
                    <Checkbox className="!mb-0"></Checkbox>
                  </Form.Item>
                  <Form.Item
                    className="flex items-center justify-center w-full !mb-0"
                    name="admin"
                  >
                    <Checkbox className="!mb-0"></Checkbox>
                  </Form.Item>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex items-center justify-end gap-4 w-full bg-white my-6">
          <Button
            type="primary"
            className="bg-color-primary h-full text-white text-lg rounded-md px-2 w-fit min-w-[200px]"
            htmlType="submit"
          >
            {intl.formatMessage({ id: "saveChanges" })}
          </Button>
          <Button
            type="primary"
            // onClick={() => close()}
            className="bg-color-light h-full border-[#FBFBFF] text-black text-lg rounded-md px-2 w-fit min-w-[200px]"
            htmlType="button"
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default ReservationsAndClients;
